import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

import Post_Img_1 from "../../img/news/post_img_1.webp";

function  News() {
    const newsList = [
        {
            title: 'Марта Мартиненко, ПриватБанк: "Wellbeing перетворився на стратегічний інструмент утримання персоналу"',
            img: Post_Img_1,
            link: 'https://delo.ua/business/marta-martinenko-privatbank-wellbeing-peretvorivsya-na-strategicnii-instrument-utrimannya-personalu-469021/#google_vignette'
        },
    ];

    return (
        <section className="mb-[60px] lg:mb-[120px]">

            <div className="container max-w-screen-xl mx-auto px-5">
                <div className="grid gap-14 md:grid-cols-3">
                    {newsList.map((item, index) => (
                        <section>

                        </section>
                    ))}
                </div>
            </div>

        </section>
    )
}

export default News;